module.exports = __webpack_public_path__ + "static/media/AP_Navbar_Logo.8b96c0d9.svg";